<template >
<div>
  <v-card class="my-2">
    <v-card-title class="title pb-0">
      Overview
      <v-spacer />
      <v-dialog v-model="editing" max-width="600px" v-if="edit">
        <v-btn color="secondary darken-2" slot="activator">
          <v-icon left>mdi-pencil</v-icon> Edit
        </v-btn>
        <v-card>
          <v-card-title class="headline">
            Edit Overview
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid" @submit.prevent="submit">
              <v-text-field v-model="modified.location.address" label="Headquarters" :rules="rules.location" :error-messages="errors.location || []" />
              <v-text-field v-model="modified.website" label="Website" :rules="rules.website" :error-messages="errors.website || []" />
              <v-select v-model="modified.size" label="Size" :rules="rules.size" :items="options.sizes" :error-messages="errors.size || []" />
              <v-select v-model="modified.industries" label="Industries" :rules="rules.industries" :items="options.industries" :error-messages="errors.industries || []" multiple chips />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn flat @click="cancel">
              Cancel
            </v-btn>
            <v-btn :color="valid ? 'success' : 'error'" :disabled="!valid" @click="submit">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-title>
    <v-layout row wrap align-content-space-around justify-center class="pt-0 pb-3 text-xs-center">
      <v-flex v-if="organization.location && organization.location.address[0]">
        <v-avatar>
          <v-icon left>mdi-map-marker</v-icon>
        </v-avatar>
        {{ organization.location.address }} (HQ)
      </v-flex>
      <v-flex v-if="organization.size">
        <v-avatar>
          <v-icon left>wc</v-icon>
        </v-avatar>
        {{ organization.size }} employees
      </v-flex>
      <v-flex v-if="organization.website">
        <v-avatar>
          <v-icon left>mdi-web</v-icon>
        </v-avatar>
        <a :class="themes.client.light.link" :href="organization.website" target="_blank">
          {{ organization.website }}
        </a>
      </v-flex>
      <v-flex xs12>
        <v-chip avatar outline :class="themes.client.dark.chip"
                v-for="industry in organization.industries" :key="industry">
          <v-avatar><v-icon>mdi-chart-bubble</v-icon></v-avatar>
          {{ industry }} Industry
        </v-chip>
      </v-flex>
    </v-layout>
  </v-card>
</div>
</template>

<script>
// Data
import industryOptions from '@/data/industries'

// Vue Component
export default {
  props: { organization: Object, edit: Boolean },
  data() {
    return {
      editing: false,
      valid: false,
      rules: {
        size: [],
        location: [],
        industries: [],
        website: [
          v =>
            /^(https?:\/\/)([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/.test(
              v
            ) || 'must be a valid uri',
        ],
      },
      errors: {},
      modified: Object.assign(
        { location: { address: null } },
        JSON.parse(JSON.stringify(this.organization))
      ),
      options: {
        sizes: [
          '1 - 15',
          '16 - 50',
          '51 - 200',
          '201 - 500',
          '501 - 1000',
          '1000+',
        ],
        industries: industryOptions,
      },
    }
  },
  methods: {
    cancel() {
      this.editing = false
      this.errors = {}
      this.modified = Object.assign(
        { location: { address: null } },
        JSON.parse(JSON.stringify(this.organization))
      )
    },
    submit() {
      if (this.valid) {
        this.update()
      }
    },
    update() {
      this.$store
        .dispatch('client/organization/update', this.modified)
        .then(errors => {
          if (errors) {
            this.errors = errors
            this.$store.dispatch(
              'snackbarError',
              'There was a problem saving the overview'
            )
          } else {
            this.$store.dispatch(
              'snackbarSuccess',
              'The overview was saved successfully'
            )
            this.editing = false
          }
        })
    },
  },
}
</script>
